(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clc-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clc-sticky-atc')) {
    class ClcStickyAtc extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('[data-sticky-bar]');
        this.dd = this.querySelector('[data-sticky-dd]');
        this.menu = this.querySelector('[data-sticky-menu]');
        this.trig = this.querySelector('[data-sticky-trig]');
        this.checkoutBtn = this.querySelector('[data-sticky-checkout]');
        this.labelEl = this.querySelector('[data-sticky-label]');
        this.offEl = this.querySelector('[data-sticky-off]');
        this.wasEl = this.querySelector('[data-sticky-was]');
        this.nowEl = this.querySelector('[data-sticky-now]');

        this.syncingFromSticky = false;
        this.harvestingPrices = false;
        this.priceCache = {};
        this.boundOnScroll = this.updateVisibility.bind(this);
        this.boundOnResize = this.updateVisibility.bind(this);
        this.boundOnDocClick = this.onDocClick.bind(this);
        this.boundOnContext = this.onBuyBoxContext.bind(this);
        this.boundOnOverlay = this.updateOverlayBlock.bind(this);

        this.trig?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleMenu();
        });
        this.checkoutBtn?.addEventListener('click', () => this.triggerCheckout());
        document.addEventListener('click', this.boundOnDocClick);
        window.addEventListener('scroll', this.boundOnScroll, { passive: true });
        window.addEventListener('resize', this.boundOnResize, { passive: true });

        this.classObserver = new MutationObserver(() => {
          this.updateVisibility();
          this.updateOverlayBlock();
        });
        this.classObserver.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['class'],
        });
        if (document.body) {
          this.classObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ['class'],
          });
        }

        this.overlayTimer = window.setInterval(this.boundOnOverlay, 500);

        this.boot();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.boundOnDocClick);
        window.removeEventListener('scroll', this.boundOnScroll);
        window.removeEventListener('resize', this.boundOnResize);
        this.classObserver?.disconnect();
        if (this.overlayTimer) window.clearInterval(this.overlayTimer);
        this.productInfo?.removeEventListener('clc:context-changed', this.boundOnContext);
      }

      boot() {
        this.productInfo = document.querySelector('product-info');
        if (!this.productInfo) {
          requestAnimationFrame(() => this.boot());
          return;
        }

        this.productInfo.addEventListener('clc:context-changed', this.boundOnContext);
        this.lastFlavorKey = this.getActiveFlavorKey();
        this.buildOptions();
        this.syncFromBuyBox();
        this.schedulePriceHarvest();
        this.updateVisibility();
        this.updateOverlayBlock();
      }

      schedulePriceHarvest(attempt = 0) {
        const prices = this.readLivePrices();
        const ready = prices.now && prices.now !== '—';
        if (!ready && attempt < 40) {
          window.setTimeout(() => this.schedulePriceHarvest(attempt + 1), 50);
          return;
        }
        this.harvestAllOptionPrices();
      }

      applyPriceCacheToMenu() {
        this.menu?.querySelectorAll('.clc-sticky-atc__opt').forEach((opt) => {
          const qty = opt.dataset.quantity;
          const cached = qty ? this.priceCache[qty] : '';
          const pp = opt.querySelector('.pp');
          if (pp && cached) pp.textContent = cached;
        });
      }

      harvestAllOptionPrices() {
        const buttons = this.getQtyButtons();
        if (!buttons.length || !this.productInfo) return;

        const original = this.getActiveQtyButton();
        const widget = this.productInfo.querySelector('clc-subscription-widget');
        this.harvestingPrices = true;

        buttons.forEach((btn) => {
          const qty = btn.dataset.quantity;
          if (!qty) return;

          buttons.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');

          const optionEl = btn.closest('clc-custom-quantity-option');
          if (optionEl && typeof optionEl.applyQuantity === 'function') {
            optionEl.applyQuantity(this.productInfo, qty);
          }

          if (widget && typeof widget.updateDisplay === 'function') {
            widget.updateDisplay();
          } else {
            this.productInfo.dispatchEvent(new CustomEvent('clc:context-changed', { bubbles: false }));
          }

          const prices = this.readLivePrices();
          if (prices.now && prices.now !== '—') {
            this.priceCache[qty] = this.formatCompactMoney(prices.now);
          }
        });

        if (original) {
          buttons.forEach((b) => b.classList.remove('is-active'));
          original.classList.add('is-active');
          const optionEl = original.closest('clc-custom-quantity-option');
          if (optionEl && typeof optionEl.applyQuantity === 'function') {
            optionEl.applyQuantity(this.productInfo, original.dataset.quantity);
          }
          if (widget && typeof widget.updateDisplay === 'function') {
            widget.updateDisplay();
          } else {
            this.productInfo.dispatchEvent(new CustomEvent('clc:context-changed', { bubbles: false }));
          }
        }

        this.harvestingPrices = false;
        this.applyPriceCacheToMenu();
        this.syncFromBuyBox();
      }

      hasBodyClass(name) {
        if (!name) return false;
        return (
          document.documentElement.classList.contains(name) ||
          Boolean(document.body?.classList.contains(name))
        );
      }

      isEnabled() {
        if (this.dataset.enablePermanently === 'true') return true;
        if (this.dataset.customizerPreview === 'true' && window.Shopify?.designMode) return true;
        return this.hasBodyClass(this.dataset.igClass) || this.hasBodyClass(this.dataset.igClassAlt);
      }

      isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      getQtyButtons() {
        if (!this.productInfo) return [];
        return Array.from(
          this.productInfo.querySelectorAll('clc-custom-quantity-option .clc-option-button')
        );
      }

      getActiveQtyButton() {
        return this.productInfo?.querySelector(
          'clc-custom-quantity-option .clc-option-button.is-active'
        );
      }

      getSubmitButton() {
        return this.productInfo?.querySelector(
          'form[data-type="add-to-cart-form"] .product-form__submit, form[data-type="add-to-cart-form"] button[name="add"]'
        );
      }

      readLivePrices() {
        const root = this.productInfo;
        if (!root) return { now: '', was: '', off: '' };
        const now = root.querySelector('[data-clc-sub-price]')?.textContent?.trim() || '';
        const cmp = root.querySelector('[data-clc-sub-compare]');
        const was =
          cmp && !cmp.hidden ? cmp.textContent?.trim() || '' : '';
        const badge = root.querySelector('[data-clc-sub-badge]');
        let off = '';
        if (badge && !badge.hidden) {
          off = badge.textContent?.trim() || '';
        }
        return { now, was, off };
      }

      formatCompactMoney(value) {
        if (!value) return '';
        return value.replace(/\.00\b/, '');
      }

      buildOptions() {
        if (!this.menu) return;
        const buttons = this.getQtyButtons();
        this.menu.innerHTML = '';
        buttons.forEach((btn, index) => {
          const label =
            btn.querySelector('.clc-qty-option__label')?.textContent?.trim() ||
            btn.getAttribute('aria-label')?.trim() ||
            btn.textContent?.trim() ||
            `Option ${index + 1}`;
          const qty = btn.dataset.quantity || String(index);
          const opt = document.createElement('button');
          opt.type = 'button';
          opt.className = 'clc-sticky-atc__opt';
          opt.setAttribute('role', 'option');
          opt.dataset.quantity = qty;
          opt.dataset.index = String(index);
          opt.innerHTML = `<span class="lbl"></span><span class="pp"></span>`;
          opt.querySelector('.lbl').textContent = label;
          if (this.priceCache[qty]) {
            opt.querySelector('.pp').textContent = this.priceCache[qty];
          }
          opt.addEventListener('click', (e) => {
            e.stopPropagation();
            this.selectOption(opt, true);
            this.closeMenu();
          });
          this.menu.appendChild(opt);
        });
      }

      selectOption(opt, pushToBuyBox) {
        if (!opt) return;
        this.menu?.querySelectorAll('.clc-sticky-atc__opt').forEach((el) => {
          el.classList.toggle('is-on', el === opt);
        });
        if (this.labelEl) this.labelEl.textContent = opt.querySelector('.lbl')?.textContent || '';

        if (pushToBuyBox) {
          const qty = opt.dataset.quantity;
          const match = this.getQtyButtons().find((btn) => btn.dataset.quantity === qty);
          if (match && !match.classList.contains('is-active')) {
            this.syncingFromSticky = true;
            match.click();
            requestAnimationFrame(() => {
              this.syncingFromSticky = false;
              this.syncFromBuyBox();
            });
          } else {
            this.syncFromBuyBox();
          }
        }
      }

      syncFromBuyBox() {
        const active = this.getActiveQtyButton();
        if (!active) return;

        if (!this.menu?.children.length) this.buildOptions();

        const qty = active.dataset.quantity;
        const opt = Array.from(this.menu?.querySelectorAll('.clc-sticky-atc__opt') || []).find(
          (el) => el.dataset.quantity === qty
        );

        if (opt) {
          this.menu?.querySelectorAll('.clc-sticky-atc__opt').forEach((el) => {
            el.classList.toggle('is-on', el === opt);
          });
          const label =
            active.querySelector('.clc-qty-option__label')?.textContent?.trim() ||
            active.getAttribute('aria-label')?.trim() ||
            opt.querySelector('.lbl')?.textContent ||
            '';
          if (this.labelEl) this.labelEl.textContent = label;
          const lbl = opt.querySelector('.lbl');
          if (lbl && label) lbl.textContent = label;
        }

        const prices = this.readLivePrices();
        if (this.nowEl) this.nowEl.textContent = this.formatCompactMoney(prices.now);
        if (this.wasEl) {
          if (prices.was) {
            this.wasEl.textContent = this.formatCompactMoney(prices.was);
            this.wasEl.hidden = false;
          } else {
            this.wasEl.textContent = '';
            this.wasEl.hidden = true;
          }
        }
        if (this.offEl) {
          if (prices.off) {
            this.offEl.textContent = `· ${prices.off}`;
            this.offEl.hidden = false;
          } else {
            this.offEl.textContent = '';
            this.offEl.hidden = true;
          }
        }

        if (opt && prices.now) {
          const compact = this.formatCompactMoney(prices.now);
          this.priceCache[qty] = compact;
          const pp = opt.querySelector('.pp');
          if (pp) pp.textContent = compact;
        }

        const submit = this.getSubmitButton();
        if (this.checkoutBtn && submit) {
          this.checkoutBtn.disabled = Boolean(submit.disabled);
        }
      }

      getActiveFlavorKey() {
        const btn = this.productInfo?.querySelector(
          'clc-custom-variants .clc-option-button.is-active[data-variant-id]'
        );
        if (!btn) return '';
        return `${btn.dataset.productId || ''}:${btn.dataset.variantId || ''}`;
      }

      onBuyBoxContext() {
        if (this.harvestingPrices) return;
        // Run after clc-subscription-widget updateDisplay on the same event.
        requestAnimationFrame(() => {
          this.syncFromBuyBox();
          const flavorKey = this.getActiveFlavorKey();
          if (flavorKey && flavorKey !== this.lastFlavorKey) {
            this.lastFlavorKey = flavorKey;
            this.harvestAllOptionPrices();
          }
        });
      }

      toggleMenu() {
        if (this.dd?.classList.contains('is-open')) this.closeMenu();
        else this.openMenu();
      }

      openMenu() {
        this.dd?.classList.add('is-open');
        this.menu?.removeAttribute('hidden');
        this.trig?.setAttribute('aria-expanded', 'true');
      }

      closeMenu() {
        this.dd?.classList.remove('is-open');
        this.menu?.setAttribute('hidden', '');
        this.trig?.setAttribute('aria-expanded', 'false');
      }

      onDocClick(e) {
        if (!this.dd?.contains(e.target)) this.closeMenu();
      }

      async triggerCheckout() {
        if (this.checkoutInFlight) return;

        // First sticky click used to no-op while price harvest was running.
        // Wait briefly instead of dropping the click.
        if (this.harvestingPrices) {
          const harvestStarted = Date.now();
          while (this.harvestingPrices && Date.now() - harvestStarted < 4000) {
            await new Promise((resolve) => window.setTimeout(resolve, 50));
          }
          if (this.harvestingPrices) return;
        }

        const productInfo = this.productInfo;
        const form = productInfo?.querySelector('form[data-type="add-to-cart-form"]');
        const submit = this.getSubmitButton();
        if (!productInfo || !form || !submit || submit.disabled) return;

        // Sync flavor + qty onto the form before submit (avoids stale / disabled id).
        const flavorBtn = productInfo.querySelector(
          'clc-custom-variants .clc-option-button.is-active[data-variant-id]:not([data-sold-out="true"])'
        );
        const idInput = form.querySelector('input[name="id"]');
        if (idInput && flavorBtn?.dataset.variantId) {
          idInput.disabled = false;
          idInput.value = flavorBtn.dataset.variantId;
        }

        const activeQty = this.getActiveQtyButton();
        const qtyOption = activeQty?.closest('clc-custom-quantity-option');
        if (qtyOption && typeof qtyOption.applyQuantity === 'function' && activeQty?.dataset.quantity) {
          qtyOption.applyQuantity(productInfo, activeQty.dataset.quantity);
        }

        const widget = productInfo.querySelector('clc-subscription-widget');
        if (widget && typeof widget.updateDisplay === 'function') {
          widget.updateDisplay();
        }

        submit.removeAttribute('aria-disabled');
        submit.classList.remove('loading');
        this.checkoutInFlight = true;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submit);
        } else {
          submit.click();
        }

        window.setTimeout(() => {
          this.checkoutInFlight = false;
        }, 2500);
      }

      getTriggerSection() {
        // "What's Inside Every Pouch" band (not the Replace comparison above it)
        return (
          document.querySelector('.hp-sale-ingredients__band--inside') ||
          document.querySelector('#shopify-section-hp_sale_ingredients_pdp .hp-sale-ingredients') ||
          document.querySelector('[data-hp-sale-ingredients]')
        );
      }

      getFooter() {
        return (
          document.querySelector('.shopify-section-group-footer-group') ||
          document.querySelector('footer') ||
          document.getElementById('shopify-section-footer')
        );
      }

      hasBlockingOverlay() {
        if (document.querySelector('cart-drawer.active, .cart-drawer.active, #CartDrawer.active')) {
          return true;
        }
        if (document.querySelector('.drawer.animate.active, .menu-drawer-container.menu-opening')) {
          return true;
        }
        // Klaviyo / Alia / generic modal dialogs (visible only)
        const dialogs = document.querySelectorAll(
          '[role="dialog"], [aria-modal="true"], .needsclick[role="dialog"], details[open].modal'
        );
        for (const el of dialogs) {
          if (!(el instanceof HTMLElement)) continue;
          const style = window.getComputedStyle(el);
          if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
            continue;
          }
          const rect = el.getBoundingClientRect();
          if (rect.width > 40 && rect.height > 40) return true;
        }
        return false;
      }

      updateOverlayBlock() {
        const blocked = this.hasBlockingOverlay();
        this.classList.toggle('is-overlay-blocked', blocked);
        if (blocked) this.closeMenu();
      }

      updateVisibility() {
        if (!this.isEnabled() || !this.isMobile()) {
          this.classList.remove('is-visible');
          this.setAttribute('aria-hidden', 'true');
          this.closeMenu();
          return;
        }

        const trigger = this.getTriggerSection();
        const footer = this.getFooter();
        // Show once ~50% of "What's Inside Every Pouch" is in view,
        // and keep showing while scrolling further down until the footer enters.
        let triggerHalfwayVisible = false;
        if (trigger) {
          const rect = trigger.getBoundingClientRect();
          const midpoint = rect.top + rect.height * 0.5;
          triggerHalfwayVisible = midpoint <= window.innerHeight;
        }
        let footerInView = false;
        if (footer) {
          const fr = footer.getBoundingClientRect();
          footerInView = fr.top < window.innerHeight;
        }

        const show = triggerHalfwayVisible && !footerInView;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (!show) this.closeMenu();
        this.updateOverlayBlock();
      }
    }

    customElements.define('clc-sticky-atc', ClcStickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
